import {createContext} from 'react'

export const SegmentContext = createContext({})
